import { call, put, select } from 'redux-saga/effects';

import { Messages } from '../../../../codegen/Localize';
import { IRemoteRefreshScheduleInfo } from '../../../../ts/models/IRemoteRefreshScheduleInfo';
import { IIdItemInfo } from '../../../../ts/models/resourceInfoParts';
import { Set } from '../../../../ts/models/Set';
import { DeleteRemoteRefreshSchedulesAction } from '../../../../ts/services/DeleteRemoteRefreshSchedulesAction';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { DeleteRemoteExtractRefreshAction } from '../../../actions/spaces/DeleteRemoteExtractRefreshAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { selectSpaceInfoItem } from '../../../selectors/SpaceInfoSelectors';
import { ServiceLocator } from '../../../ServiceLocator';

export function* handleDeleteRemoteExtractRefreshAction(action: DeleteRemoteExtractRefreshAction) {
  try {
    const datasource: IIdItemInfo = yield select(selectSpaceInfoItem);
    yield call(executeDeleteRemoteExtractRefreshAction, datasource, action.schedules);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function executeDeleteRemoteExtractRefreshAction(
  datasource: IIdItemInfo,
  items: IRemoteRefreshScheduleInfo[]
) {
  const deleteRemoteExtractRefreshService =
      ServiceLocator.get<DeleteRemoteRefreshSchedulesAction>('DeleteRemoteRefreshSchedulesAction');
  const context = ServiceLocator.getAngularActionContext();
  return deleteRemoteExtractRefreshService.execute(context, datasource, Set.fromIdItemArray(items));
}
